import {
  CalendarIntegrationShowcase,
  CommunityFeatures,
  CourseBuilderShowcase,
  DashboardShowcase,
  FAQ,
  FeaturesGrid,
  FinalCTA,
  HeroSection,
  LogoCloud,
  Pricing,
  ProductTypes,
  Testimonials,
  VideoPlayerShowcase,
} from "@/components/landing";
import type { MarketingPageConfig } from "@/lib/marketing-page-renderer";

export const homeMarketingPageConfig: MarketingPageConfig = {
  pageKey: "home",
  sections: [
    {
      id: "hero",
      render: ({ experimentId, getCtaCopy, variantId }) => (
        <HeroSection
          experimentId={experimentId}
          primaryCtaText={getCtaCopy("hero-primary")}
          variantId={variantId}
        />
      ),
    },
    { id: "logo-cloud", render: () => <LogoCloud /> },
    { id: "features", render: () => <FeaturesGrid /> },
    { id: "video-showcase", render: () => <VideoPlayerShowcase /> },
    { id: "course-builder", render: () => <CourseBuilderShowcase /> },
    { id: "product-types", render: () => <ProductTypes /> },
    { id: "calendar-integration", render: () => <CalendarIntegrationShowcase /> },
    { id: "community", render: () => <CommunityFeatures /> },
    { id: "dashboard", render: () => <DashboardShowcase /> },
    {
      id: "pricing",
      render: ({ experimentId, getCtaCopy, variantId }) => (
        <Pricing
          experimentId={experimentId}
          primaryCtaText={getCtaCopy("pricing-primary")}
          variantId={variantId}
        />
      ),
    },
    { id: "testimonials", render: () => <Testimonials /> },
    { id: "faq", render: () => <FAQ /> },
    {
      id: "final-cta",
      render: ({ experimentId, getCtaCopy, variantId }) => (
        <FinalCTA
          experimentId={experimentId}
          primaryCtaText={getCtaCopy("final-cta-primary")}
          variantId={variantId}
        />
      ),
    },
  ],
  defaultSectionOrder: [
    "hero",
    "logo-cloud",
    "features",
    "video-showcase",
    "course-builder",
    "product-types",
    "calendar-integration",
    "community",
    "dashboard",
    "pricing",
    "testimonials",
    "faq",
    "final-cta",
  ],
  requiredSectionIds: ["hero", "pricing", "faq", "final-cta"],
  ctaSlots: [
    {
      slotId: "hero-primary",
      defaultCopy: "Start Creating",
      approvedCopy: ["Start Creating", "Start Selling Free", "Launch Your Store"],
    },
    {
      slotId: "pricing-primary",
      defaultCopy: "Start Creating — It's Free",
      approvedCopy: ["Start Creating — It's Free", "Start Selling for Free", "Launch with 5% Fees"],
    },
    {
      slotId: "final-cta-primary",
      defaultCopy: "Create Your Account",
      approvedCopy: ["Create Your Account", "Start Selling Today", "Launch Your First Product"],
    },
  ],
};
